(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/views/play_desktop.js') >= 0) return;  svs.modules.push('/modules/maltipset/views/play_desktop.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.maltipset=_svs.maltipset||{};
_svs.maltipset.templates=_svs.maltipset.templates||{};
svs.maltipset.templates.play = Handlebars.template({"0":function(container,depth0,helpers,partials,data) {
    return "";
},"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n"
    + ((stack1 = (lookupProperty(helpers,"campaignFlerp")||(depth0 && lookupProperty(depth0,"campaignFlerp"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"maltipset",false,false,{"name":"campaignFlerp","hash":{},"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":2,"column":43}}})) != null ? stack1 : "")
    + "\n  <div id=\"maltipset-betslipoverview-dimmer\" class=\"maltipset-betslipoverview-dimmer\"></div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = "";

  stack1 = ((helper = (helper = lookupProperty(helpers,"isMobile") || (depth0 != null ? lookupProperty(depth0,"isMobile") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"isMobile","hash":{},"fn":container.program(0, data, 0),"inverse":container.program(1, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":4,"column":13}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"isMobile")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + "\n<div id=\"game\"></div>\n";
},"useData":true});
Handlebars.partials['svs-maltipset-play'] = svs.maltipset.templates.play;
})(svs, Handlebars);


 })(window);